export default __webpack_public_path__ + "images/sweep2.ec546317cf2cbda8cc5a6f1f214d5bfc.png";